// src/components/discovery/SkeletonCard.jsx
//
// Loading-state placeholders that mirror the real DropCard/
// CreatorCard shapes, so the grid doesn't shift layout once real
// content arrives (this is what actually reduces perceived wait time,
// per the skeleton-screens research — not the shimmer itself, the
// structure preview). Replaces the current static "Loading Gallery…"
// text in Discover.jsx.

import "./SkeletonCard.css";

export function SkeletonDropCard({ compact = false }) {
  return (
    <div className={`gal-dc gal-skeleton${compact ? " gal-dc--rail" : ""}`} aria-hidden="true">
      <div className="gal-skeleton-thumb" />
      <div className="gal-dc-body">
        <div className="gal-skeleton-line gal-skeleton-line--avatar-row" />
        <div className="gal-skeleton-line gal-skeleton-line--title" />
        <div className="gal-skeleton-line gal-skeleton-line--foot" />
      </div>
    </div>
  );
}

export function SkeletonCreatorCard({ compact = false }) {
  return (
    <div className={`gal-cc gal-skeleton${compact ? " gal-cc--rail" : ""}`} aria-hidden="true">
      <div className="gal-skeleton-banner" />
      <div className="gal-cc-av-wrap">
        <div className="gal-skeleton-avatar" />
      </div>
      <div className="gal-cc-body">
        <div className="gal-skeleton-line gal-skeleton-line--title" />
        <div className="gal-skeleton-line gal-skeleton-line--foot" />
      </div>
    </div>
  );
}

// Convenience - a row of skeleton cards for an initial grid load.
// count defaults to a sensible number for a 3-column grid.
export function SkeletonDropGrid({ count = 6 }) {
  return (
    <>
      {Array.from({ length: count }).map((_, i) => (
        <SkeletonDropCard key={i} />
      ))}
    </>
  );
}